// extracted by mini-css-extract-plugin
export default {"invalid":"ModeloGpsEdit_invalid__xrTnT","spinnerContainer":"ModeloGpsEdit_spinnerContainer__4ImtC"};